import { render, staticRenderFns } from "./ResponsibilityDirectoryPage.vue?vue&type=template&id=ea7bdafe&scoped=true"
import script from "./ResponsibilityDirectoryPage.vue?vue&type=script&lang=js"
export * from "./ResponsibilityDirectoryPage.vue?vue&type=script&lang=js"
import style0 from "./ResponsibilityDirectoryPage.vue?vue&type=style&index=0&id=ea7bdafe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea7bdafe",
  null
  
)

export default component.exports